/**
 * Download & media placeholders.
 * Assets are genuinely unavailable — never fabricate files or claims.
 */

export const DOWNLOAD_TYPES = [
  {
    id: "datasheet",
    name: "Datasheet",
    status: "Coming Soon",
    description:
      "Technical datasheets will be published as product documentation is completed.",
  },
  {
    id: "installation-manual",
    name: "Installation Manual",
    status: "Coming Soon",
    description:
      "Installation and commissioning manuals will be issued with the expanding catalogue.",
  },
  {
    id: "warranty",
    name: "Warranty Information",
    status: "Coming Soon",
    description:
      "Warranty terms and coverage details will be published alongside product releases.",
  },
  {
    id: "cad",
    name: "CAD Files",
    status: "Coming Soon",
    description:
      "Mechanical and electrical CAD assets will be made available for engineering coordination.",
  },
  {
    id: "videos",
    name: "Videos",
    status: "Coming Soon",
    description:
      "Application and installation video content will follow as the catalogue matures.",
  },
];

export const GALLERY_PLACEHOLDER = {
  title: "Engineering Visual",
  status: "Image Under Validation",
  description:
    "Approved product photography for this model is not yet published. Specifications and quote requests use verified catalogue data only.",
};

export const CERTIFICATION_STATEMENT = {
  title: "Compliance & Certification",
  body: [
    "DEBSUN Technologies is actively expanding independent testing, compliance documentation and certification across its product portfolio.",
    "Where specific certification or project documentation is required, our engineering team will advise available validation and applicable standards.",
  ],
  contactCta: "Discuss validation requirements",
};
